class YoutubeVideo {

    constructor(options) {
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
        this.playVideo = this.playVideo.bind(this);
        if (options == null) { options = {}; }
        const __defaults = {
            height: '390',
            width: '640',
            videoId: 'hy9OhNTHv0w',
            elementID: 'player',
            events: {
                onStateChange: this.onPlayerStateChange,
            },
        };

        this.options = $.extend(true, __defaults, options);

        this.element = this.options.elementID;
        delete this.options.elementID;

        this.setupVideo();
    }

    setupVideo() {
        // 2. This code loads the IFrame Player API code asynchronously.
        const tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // 3. This function creates an <iframe> (and YouTube player)
        //    after the API code downloads.
        return window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player(this.element, this.options);

            return $(`#${ this.element }`).parent().find('[data-play]').click(e => {
                e.preventDefault();
                return this.togglePlayState();
            });
        };
    }

    onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
            return this.stopVideo();
        }
        if ((event.data === YT.PlayerState.PLAYING) && !this.done) {
            setTimeout(this.stopVideo, 6000);
            return this.done = true;
        }
    }

    togglePlayState() {
        if (this.player.getPlayerState() === YT.PlayerState.PLAYING) {
            return this.stopVideo();
        }
        return this.playVideo();

    }

    stopVideo() {
        this.player.stopVideo();
        return $(`#${ this.element }`).parent().removeClass('playing');
    }

    playVideo() {
        $(`#${ this.element }`).parent().addClass('playing');
        return this.player.playVideo();
    }
}

export default YoutubeVideo;
